module.exports = __webpack_public_path__ + "static/media/icon_file.3c2e47cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file.svg
// module id = 235
// module chunks = 0